export default __webpack_public_path__ + "static/media/ai.d68444cf.png";